<div class="virtual-keyboard-container">
  <div class="virtual-keyboard-grid" (click)="getNumber($event)">
    <div class="virtual-keyboard-numpad flex-center" _key="1">1</div>
    <div class="virtual-keyboard-numpad flex-center" _key="2">2</div>
    <div class="virtual-keyboard-numpad flex-center" _key="3">3</div>
    <div class="virtual-keyboard-numpad flex-center" _key="4">4</div>
    <div class="virtual-keyboard-numpad flex-center" _key="5">5</div>
    <div class="virtual-keyboard-numpad flex-center" _key="6">6</div>
    <div class="virtual-keyboard-numpad flex-center" _key="7">7</div>
    <div class="virtual-keyboard-numpad flex-center" _key="8">8</div>
    <div class="virtual-keyboard-numpad flex-center" _key="9">9</div>
    <div class="virtual-keyboard-numpad flex-center" _key="12">
      <img [src]="images.CROSS" alt="back" _key="12" />
    </div>
    <div class="virtual-keyboard-numpad flex-center" _key="0">0</div>
    <ng-container *ngIf="(indoSpecific && showTripleZeros) else universalTpl">
      <div class="virtual-keyboard-numpad flex-center" _key="000">000</div>
    </ng-container>
    <ng-template #universalTpl>
      <div
      class="virtual-keyboard-numpad flex-center"
      _key="11"
      *ngIf="showDecimal"
    >
      {{ indoSpecific ? ',' : '.' }}
    </div>
    </ng-template>
  </div>
</div>
